<template>
    <div>
        <span @click.stop="projectColumn.property_name === 'pin'" v-if="projectColumn.property_name === 'pin'">
            <i class="fa fa-thumb-tack pin-red" v-if="projects.pin_project === 1" @click.prevent.stop="pinUnpinProject(projects.id, 0)"></i>
            <i class="fa fa-thumb-tack pin-black" v-else @click.prevent.stop="pinUnpinProject(projects.id, 1)"></i>
        </span>
    </div>
</template>

<script>
export default {
    name: "pin-project",
    props: ['projectColumn', 'projects'],

    data() {
        return {

        }
    },

    methods: {
        pinUnpinProject(projectId, value) {
            this.$emit("updateLoader", true);
            axios.post(route('api.pin-unpin-project', {projectId: projectId, value, value})).then((response) => {
                this.$emit("updateLoader", false);
                if(response.data.status === 1) {
                    this.$emit("fetchProjectData");
                    
                    this.getToast(5000).fire({
                        type: 'success',
                        title: response.data.message
                    });
                }
                else if(response.data.status === 0) {
                    this.getToast(5000).fire({
                        type: 'error',
                        title: response.data.message
                    });
                }

            }).catch(error => {
                this.$emit("updateLoader", false);
                this.getToast(5000).fire({
                    type: 'error',
                    title: error
                });
            });
        }
    }
}
</script>